import { Star } from 'lucide-react';
import { SCORE_BAND_TONE, SUPPLIER_RATING_MAX } from '../constants';

/**
 * One supplier's aggregate score, as a compact badge.
 *
 * Deliberately renders the band even when `score` is null: a supplier with no
 * ratings yet reads as "unrated", not as a zero. Treating an unrated supplier
 * as bad would make the scorecard a moat against new suppliers — the same
 * reasoning the server applies when it scores an unrated bidder as neutral in
 * compareRfqQuotes (src/shared/procurement/rfq-comparison.js).
 */
export function SupplierScoreBadge({
  score,
  band,
  ratingCount,
  showCount = true,
}: {
  score: number | null;
  band: string;
  ratingCount: number;
  showCount?: boolean;
}) {
  const tone = SCORE_BAND_TONE[band] || SCORE_BAND_TONE.unrated;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${tone}`}>
      <Star className="w-3 h-3" />
      {score === null ? 'Unrated' : `${score.toFixed(1)}/${SUPPLIER_RATING_MAX}`}
      {showCount && ratingCount > 0 && (
        <span className="font-normal opacity-70">({ratingCount})</span>
      )}
    </span>
  );
}

export default SupplierScoreBadge;
